// extracted by mini-css-extract-plugin
module.exports = {"fontSizeSmall":"style_fontSizeSmall__1pRsm"};